<template>
  <div class="mobile">
    <van-nav-bar
    v-if="source==1"
    title="账号安全"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <div class="approve-box text-c">
      <img class="approve" :src="img.approve">
      <div class="f-16 f-w">手机号绑定成功</div>
    </div>
    <!-- <div class="f-12 c-gray mt-25 text-c">恭喜您获得以下好礼！</div>
    <div class="mt-25">
      <div class="gift_box">
        <div class="f-12 gift_title">XXX积分 1000</div>
        <div class="getBtn">领取</div>
      </div>
      <div class="gift_box">
        <div class="f-12 gift_title">雷克萨斯镂空机械腕表-男士 1枚</div>
        <div class="getBtn">领取</div>
      </div>
      <div class="gift_box">
        <div class="f-12 gift_title">勋章：XXX1</div>
        <div class="getBtn">领取</div>
      </div>
    </div> -->
    <div class="iknowBtn" @click="goback()">我知道了</div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon,NavBar} from 'vant';
  export default {
    data () {
      return {
        name:'',
        type:0,
        img:{
          approve: require('../../../assets/img/member/mobileaudit.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.isTabbar({state: true})
      this.weburl=process.env.VUE_APP_URL
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      goback(){
        this.$router.push({name:'MySafety',params:{source:this.source}});
        // var params={
        //   url:this.weburl+'/lexus/my/cars',
        //   isReturn: true 
        // }
        // this.$appService.openWebView(params)
      },
      onClickLeft(){
        this.$router.go(-1)
      },
      
    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Field.name]:Field,
      [Button.name]:Button,
      [Icon.name]:Icon,
      [NavBar.name]:NavBar
    }
  }
</script>

<style lang="scss">
  .mobile{
    position: absolute;
    height: 100%;
    width: 100%;
    background: #f1f1f1;
    .mt-25{
      margin-top: 25px;
    }
    .approve-box{
      margin-top: 40%;
      
      .approve{
        width: 36px;
        height: 50px;
        margin-bottom: 30px;
      }
    }
    .gift_box{
      display: flex;
      margin: 0 15px;
      padding: 10px 15px;
      align-items: center;
      background-color:#fff;
      border-bottom:0.5px solid rgba(0,0,0,.1);
      .gift_title{
        flex: 1;
      }
      .getBtn{
        float: right;
        color: #fff;
        font-size:12px;
        padding:5px 15px;
        border-color: #FFBB00;
        background-color:#FFBB00;
      }
    }
    .iknowBtn{
      color: #fff;
      font-size:12px;
      text-align: center;
      padding:12px 25px;
      margin: 50px 20%;
      border-color: #FFBB00;
      background-color:#FFBB00;
    }

  }
</style>
